/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_Confirm_DeleteInputs */

const he_notifications_delete_confirm_delete = /** @type {(inputs: Notifications_Delete_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביטול התראה`)
};

const en_notifications_delete_confirm_delete = /** @type {(inputs: Notifications_Delete_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Notifications_Delete_Confirm_DeleteInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_confirm_delete = /** @type {((inputs?: Notifications_Delete_Confirm_DeleteInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_Confirm_DeleteInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_confirm_delete(inputs)
	return en_notifications_delete_confirm_delete(inputs)
});